import axios from 'axios';
import dayjs from 'dayjs';
import qs from 'qs';

import { ENV } from '@hero/configs';
import { storage } from '@hero/utils';

import { configs } from '../../configs';
import { createAxios } from '../../utils/createAxios';

export const api = createAxios(configs.baseUrl.productService);

/**
 * @typedef {Object} SendEventParams
 * @property {string} brand
 * @property {string} entryBrand
 */

/**
 * @typedef {Object} PageInfo
 * @property {string} url
 * @property {number} height
 * @property {number} width
 * @property {string} type
 */

/**
 * @typedef {Object} DeviceInfo
 * @property {string} appName
 * @property {string} userAgent
 * @property {number} height
 * @property {number} width
 * @property {string} platform
 * @property {string} deviceType
 */

/**
 * @typedef {Object} UserInfo
 * @property {string} customerType
 * @property {string} gaClientId
 */

/**
 * @typedef {Object} SendEventData
 * @property {string} eventType
 * @property {string} eventSubType
 * @property {string} deviceTimeCreated
 * @property {PageInfo} page
 * @property {DeviceInfo} device
 * @property {UserInfo} [user]
 * @property {string} browserUUID
 */

/**
 * @typedef {Object} SendEventArgs
 * @property {SendEventParams} params
 * @property {SendEventData} data
 */

/**
 * Sends an event to the clickstream API
 * @param {SendEventArgs} args - The event arguments
 * @returns {Promise<void>}
 */
export const sendClickStreamEvent = async ({ params, data }) => {
  const baseUrl = ENV.CLICKSTREAM_API_BASE_URL;

  let clickStreamGuessToken = storage.getClickStreamGuessToken();
  if (!clickStreamGuessToken) {
    const response = await api.post('/pwa/guest-token');
    const tokenData = response?.data?.data;

    if (!tokenData) {
      return;
    }

    const TOKEN_EXPIRE_BUFFER = 60 * 60; // 60 seconds * 60 minutes = 3600 seconds = 1 hour
    clickStreamGuessToken = tokenData.access_token;
    const expirationDate = dayjs()
      .add(tokenData.expires_in - TOKEN_EXPIRE_BUFFER, 'second')
      .toDate();

    storage.setClickStreamGuessToken(clickStreamGuessToken, {
      expires: expirationDate
    });
  }

  try {
    // Using qs to stringify query parameters
    const queryString = qs.stringify(params);

    await axios.post(`${baseUrl}?${queryString}`, data, {
      headers: {
        'Content-Type': 'application/json',
        anonymousid: data.browserUUID,
        'app-version': ENV.REACT_APP_BUILD_VERSION,
        authorization: `Bearer ${clickStreamGuessToken}`
      }
    });
  } catch (error) {
    return error;
  }
};
